function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  rx: 30,
  fill: "black",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6803 27.5898L39.0252 28.2351C38.819 28.4366 38.5447 28.5476 38.2515 28.5476C37.9585 28.5476 37.6839 28.4366 37.4777 28.2351L30.0045 20.9244L22.5226 28.2432C22.3168 28.4447 22.0421 28.5556 21.7491 28.5556C21.4561 28.5556 21.1813 28.4447 20.9753 28.2432L20.32 27.6018C19.8933 27.1848 19.8933 26.5055 20.32 26.0884L29.228 17.3432C29.4339 17.1419 29.7082 17 30.0038 17L30.0072 17C30.3004 17 30.5747 17.142 30.7806 17.3432L39.6803 26.0647C39.8865 26.2661 39.9997 26.5425 40 26.8291C40 27.1159 39.8865 27.3885 39.6803 27.5898Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7143 19.8889C31.1088 19.8889 31.4286 20.2122 31.4286 20.6111L31.4286 42.2778C31.4286 42.6766 31.1088 43 30.7143 43L29.2857 43C28.8912 43 28.5714 42.6766 28.5714 42.2778L28.5714 20.6111C28.5714 20.2122 28.8912 19.8889 29.2857 19.8889L30.7143 19.8889Z",
  fill: "white"
});

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.71606ccd.svg";
export { ForwardRef as ReactComponent };